"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = App;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var routes_1 = require("./routes");
var content_1 = require("./components/dialogs/content");
var message_1 = require("./components/dialogs/message");
var error_boundary_1 = require("./components/common/error-boundary");
var session_timeout_warning_1 = require("./components/common/session-timeout-warning");
var toast_1 = require("./components/common/toast");
var auth_1 = require("./features/slices/auth");
var baseQueryWithReauth_1 = require("./utils/baseQueryWithReauth");
function App() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    // Initialize auth state from localStorage on app load
    (0, react_2.useEffect)(function () {
        var initAuth = function () {
            try {
                var storedAuth = localStorage.getItem(baseQueryWithReauth_1.AUTH_STORAGE_KEY);
                if (storedAuth) {
                    var parsed = JSON.parse(storedAuth);
                    // Check if token exists and is not expired
                    if (parsed.token && parsed.expires_at) {
                        var expiresAt = new Date(parsed.expires_at);
                        if (expiresAt > new Date()) {
                            dispatch((0, auth_1.setCredentials)(parsed));
                            return;
                        }
                    }
                    // Clear invalid/expired auth
                    localStorage.removeItem(baseQueryWithReauth_1.AUTH_STORAGE_KEY);
                }
            }
            catch (error) {
                console.error("Error initializing auth:", error);
                localStorage.removeItem(baseQueryWithReauth_1.AUTH_STORAGE_KEY);
            }
            dispatch((0, auth_1.setLoading)(false));
        };
        initAuth();
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsx)(error_boundary_1.ErrorBoundary, { children: (0, jsx_runtime_1.jsxs)(react_1.HeroUIProvider, { navigate: navigate, disableAnimation: true, children: [(0, jsx_runtime_1.jsx)(routes_1.AppRoutes, {}), (0, jsx_runtime_1.jsx)(content_1.ContentDialog, {}), (0, jsx_runtime_1.jsx)(message_1.MessageDialog, {}), (0, jsx_runtime_1.jsx)(session_timeout_warning_1.SessionTimeoutWarning, {}), (0, jsx_runtime_1.jsx)(toast_1.ToastContainer, {})] }) }));
}
